/* CUSTOM CODE START */
(function () {
  function initAll(root) {
    root.querySelectorAll('[data-ucn-nav]').forEach(initNav);
  }

  function initNav(nav) {
    if (nav.dataset.ucnNavInitialized === 'true') return;
    nav.dataset.ucnNavInitialized = 'true';

    var overlay = nav.querySelector('.ucn-nav-overlay');
    var toggleButton = nav.querySelector('[data-ucn-nav-toggle]');
    var closeButton = nav.querySelector('[data-ucn-nav-close]');
    var mobileToggles = nav.querySelectorAll('[data-ucn-mob-toggle]');
    var searchTriggers = nav.querySelectorAll('[data-ucn-search-trigger]');
    var mobileLinks = nav.querySelectorAll('.ucn-nav-overlay a');
    var locTrigger = nav.querySelector('[data-ucn-loc-trigger]');
    var locBack = nav.querySelector('[data-ucn-loc-back]');
    var mainView = nav.querySelector('[data-ucn-main]');
    var locPanel = nav.querySelector('[data-ucn-loc-panel]');

    function setBodyLocked(locked) {
      document.documentElement.classList.toggle('ucn-nav-open', locked);
      document.body.style.overflow = locked ? 'hidden' : '';
    }

    function showLocPanel() {
      if (!mainView || !locPanel) return;
      mainView.setAttribute('hidden', '');
      locPanel.removeAttribute('hidden');
    }

    function hideLocPanel() {
      if (!mainView || !locPanel) return;
      locPanel.setAttribute('hidden', '');
      mainView.removeAttribute('hidden');
    }

    function closeOverlay() {
      if (!overlay || !toggleButton) return;
      overlay.classList.remove('open');
      toggleButton.classList.remove('open');
      toggleButton.setAttribute('aria-expanded', 'false');
      setBodyLocked(false);
      hideLocPanel();
    }

    function openOverlay() {
      if (!overlay || !toggleButton) return;
      overlay.classList.add('open');
      toggleButton.classList.add('open');
      toggleButton.setAttribute('aria-expanded', 'true');
      setBodyLocked(true);
    }

    function toggleOverlay() {
      if (!overlay) return;
      if (overlay.classList.contains('open')) {
        closeOverlay();
      } else {
        openOverlay();
      }
    }

    function openSearch() {
      closeOverlay();

      var searchModal = document.getElementById('search-modal');
      if (searchModal && typeof searchModal.showDialog === 'function') {
        searchModal.showDialog();
        return;
      }

      var nativeSearchButton = document.querySelector('search-button button');
      if (nativeSearchButton) {
        nativeSearchButton.click();
        return;
      }

      window.location.assign('/search');
    }

    if (toggleButton) {
      toggleButton.addEventListener('click', toggleOverlay);
    }

    if (closeButton) {
      closeButton.addEventListener('click', closeOverlay);
    }

    if (locTrigger) {
      locTrigger.addEventListener('click', showLocPanel);
    }

    if (locBack) {
      locBack.addEventListener('click', hideLocPanel);
    }

    if (overlay) {
      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) {
          closeOverlay();
        }
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && overlay && overlay.classList.contains('open')) {
        closeOverlay();
      }
    });

    mobileToggles.forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('.ucn-mob-item');
        if (!item) return;
        var isOpen = item.classList.toggle('open');
        button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    mobileLinks.forEach(function (link) {
      link.addEventListener('click', closeOverlay);
    });

    searchTriggers.forEach(function (button) {
      button.addEventListener('click', openSearch);
    });

    var mediaQuery = window.matchMedia('(min-width: 901px)');
    function handleDesktopChange(event) {
      if (event.matches) {
        closeOverlay();
      }
    }

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleDesktopChange);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(handleDesktopChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
/* CUSTOM CODE END */
